import React from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useEffect } from 'react'

const Addusersmodal = ({ show, onClose, userId, createusers,  inputData,  rolls }) => {
  const [project, setProject] = React.useState('')
  const [name, setName] = React.useState('')
  const [mobilenumber, setMobileNumber] = React.useState('')
  const [Email, setEmail] = React.useState('')
  const [Roll, setRoll] = React.useState('')
  const [wing, setWing] = React.useState('')
  const [room, setRoom] = React.useState('')
  const [filteredWings, setFilteredWings] = React.useState([])

  const [nameError, setNameError] = React.useState('')
  const [numberError, setNumberError] = React.useState('')
  const [emailError, setEmailError] = React.useState('')
  const [roomError, setRoomError] = React.useState('')
  const [projectError, setProjectError] = React.useState('')
  const [rollError, setrollError] = React.useState('')
  const [wingError, setWingError] = React.useState('')
  const [loading, setLoading] = React.useState(false)

   useEffect(() => {
      console.log('Modal inputData updated:', inputData)
    }, [inputData])

    useEffect(()=>{
      console.log('Modal inputData updated:', rolls)
    },[rolls])
  

  if (!show) return null

  const uniqueProjects = Array.from(
    new Map(
      inputData.map(item => [
        item.projectId,
        { id: item.projectId, name: item.projectName }
      ])
    ).values()
  )

  const userolls = Array.from(
    new Map(
      rolls.map(item => [
        item.rollId,
        { id: item.rollId, 
        name: item.rollName 
        }
      ])
    ).values()
  )

  const handleName = e => {
    const value = e.target.value
    setName(value)
    setNameError(value ? '' : 'Name is required.')
  }

  const handleNumber = e => {
    const value = e.target.value
    setMobileNumber(value)
    setNumberError(value ? '' : 'Mobile Number is required.')
  }

  const handleEmail = e => {
    const value = e.target.value
    setEmail(value)
    setEmailError(value ? '' : 'Email is required.')
  }

  const handleRoll = e => {
    const value = e.target.value
    setRoll(value)
    setrollError(value ? '' : 'Roll is required.')
  }

  const handleRoom = e => {
    const value = e.target.value
    setRoom(value)
    setRoomError(value ? '' : 'Room is required.')
  }

   const handleProjectChange = e => {
    const selectedProjectId = e.target.value
    setProject(selectedProjectId)
    setProjectError('')
    setWing('')

    const wings = inputData.filter(
      item => String(item.projectId) === String(selectedProjectId)
    )

    setFilteredWings(wings)
  }

  const handleWingChange = e => {
    setWing(e.target.value)
    if (e.target.value) setWingError('')
  }

  const handleSubmit = e => {
    e.preventDefault()

    let valid = true
    if (!name) {
      setNameError('Name is required.')
      valid = false
    }
    if (!mobilenumber) {
      setNumberError('Mobile Number is required.')
      valid = false
    }
    if (!Email) {
      setEmailError('Email is required.')
      valid = false
    }
    if (!project) {
      setProjectError('Project is required.')
      valid = false
    }
    if (!Roll) {
      setrollError('Roll is required.')
      valid = false
    }
    if (!wing) {
      setWingError('Wing is required.')
      valid = false
    }
    if (!room) {
      setRoomError('Room is required.')
      valid = false
    }

    if (!valid) return


    const allusers = {
      ProjectID: Number(project),
      Name: name.trim(),
      MobileNo: mobilenumber,
      EmailID: Email.trim(),
      RoleID: Number(Roll),
      Wing: wing,
      RoomNo: room
    }

    // console.log('POST PAYLOAD:', allusers) 
    setLoading(true)
    createusers(allusers)

    // Reset form after submission
    setTimeout(() => {
      setProject('')
      setProjectError('')
      setWing('')
      setWingError('')
      setName('')
      setNameError('')
      setMobileNumber('')
      setNumberError('')
      setEmail('')
      setEmailError('')
      setRoll('')
      setrollError('')
      setRoom('')
      setRoomError('')
      setLoading(false)
    }, 1500)
  }

  return (
    <>
      <div
        className="modal-backdrop show"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(20px) saturate(180%)',
          WebkitBackdropFilter: 'blur(10px)'
        }}
      ></div>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title text-bold fs-3">Create Users</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                ></button>
              </div>
              <div className="modal-body">
                
                <div className="mb-3">
                  <label className="form-label text-bold">User Name</label>{' '}
                  <span style={{ color: 'red' }}>*</span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Please enter user name"
                    value={name}
                    onChange={handleName}
                    required
                  />
                  {nameError && (
                    <div className="alert alert-danger mt-2">{nameError}</div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label text-bold">Mobile Number</label>{' '}
                  <span style={{ color: 'red' }}>*</span>
                  <input
                    type="tel"
                    className="form-control"
                    value={mobilenumber}
                    onChange={handleNumber}
                    id="phone"
                    name="phone"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="Please enter a mobile number"
                    maxLength="10"
                  />
                  {numberError && (
                    <div className="alert alert-danger mt-2">{numberError}</div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label text-bold">Enter Email</label>{' '}
                  <span style={{ color: 'red' }}>*</span>
                  <input
                    type="email"
                    id="email"
                    value={Email}
                    onChange={handleEmail}
                    name="email"
                    placeholder="Enter your email address"
                    className="form-control"
                  />
                  {emailError && (
                    <div className="alert alert-danger mt-2">{emailError}</div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label text-bold">
                    Select Project <span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    className="form-control"
                    value={project}
                    onChange={handleProjectChange}
                  >
                    <option value="">Choose Project</option>
                    {uniqueProjects.map(p => (
                      <option key={p.id} value={p.id}>
                        {p.name}
                      </option>
                    ))}
                  </select>
                  {projectError && (
                    <div className="alert alert-danger mt-2">
                      {projectError}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label text-bold">Enter Roll</label>{' '}
                  <span style={{ color: 'red' }}>*</span>
                  <select
                    className="form-control"
                    value={Roll}
                    onChange={handleRoll}
                    required
                  >
                    <option value="">Choose Roll</option>
                    {userolls.map(p => (
                      <option key={p.id} value={p.id}>
                        {p.name}
                      </option>
                    ))}
                  </select>
                  {rollError && (
                    <div className="alert alert-danger mt-2">{rollError}</div>
                  )}
                </div>
                <div className="mb-3">
                  <div className="mb-3">
                  <label className="form-label text-bold">
                    Select Wing <span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    className="form-control"
                    value={wing}
                    onChange={handleWingChange}
                    disabled={!project}
                  >
                    <option value="">Choose Wing</option>
                    {filteredWings.map(w => (
                      <option key={w.wingId} value={w.wingId}>
                        {w.wingName}
                      </option>
                    ))}
                  </select>
                  {wingError && (
                    <div className="alert alert-danger mt-2">{wingError}</div>
                  )}
                </div>
                </div>
                <div className="mb-3">
                  <label className="form-label text-bold">
                    Enter Room Number
                  </label>{' '}
                  <span style={{ color: 'red' }}>*</span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Please enter room number"
                    value={room}
                    onChange={handleRoom}
                    required
                  />
                  {roomError && (
                    <div className="alert alert-danger mt-2">{roomError}</div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loading}
                >
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
      <ToastContainer />
    </>
  )
}

export default Addusersmodal
